import React, { useState } from 'react';
import { Button, Card, Typography, App } from 'antd';
import { CopyOutlined, DeleteOutlined, EditOutlined } from '@ant-design/icons';
import { BaseCardModel, CommonEditComponentProps } from '../../dto/model';

const { Title } = Typography;

type CommonCardProps<T extends BaseCardModel> = {
  model: T;
  onSubmit: (form: T) => void;
  onDelete: (form: T) => void;
  onDuplicate: (model: T) => void;
  EditComponent: React.ComponentType<CommonEditComponentProps<T>>;
};

export const CommonCard = <T extends BaseCardModel>({ model, onSubmit, onDelete, onDuplicate, EditComponent }: CommonCardProps<T>) => {
  const { modal } = App.useApp();
  const [shouldEdit, setShouldEdit] = useState(false);
  const [currentModel] = useState<T>(model);

  const setEditDisplay = (status: boolean) => {
    setShouldEdit(status);
  };

  const deleteCard = () => {
    onDelete(model);
  };

  const showDeleteConfirm = () => {
    modal.confirm({
      title: 'Are you sure you want to delete this?',
      icon: <DeleteOutlined />,
      content: 'This action cannot be undone.',
      okText: 'Yes',
      okType: 'danger',
      cancelText: 'No',
      onOk() {
        deleteCard();
      },
    });
  };

  const handleDuplicate = () => {
    const duplicated = { ...model };
    onDuplicate(duplicated);
  };

  return (
    <Card style={{ marginBottom: '25px' }}>
      {shouldEdit ? (
        <div>
          <EditComponent model={currentModel} onSubmit={onSubmit} onCancel={() => setEditDisplay(false)} />
        </div>
      ) : (
        <>
          <Title level={3}>{currentModel.name}</Title>
          <p>{currentModel.description}</p>

          <Button onClick={() => setEditDisplay(true)} icon={<EditOutlined />} style={{ marginRight: '10px' }}>
            Edit
          </Button>
          <Button onClick={handleDuplicate} icon={<CopyOutlined />} style={{ marginRight: '10px' }}>
            Duplicate
          </Button>
          <Button onClick={showDeleteConfirm} icon={<DeleteOutlined />}>
            Delete
          </Button>
        </>
      )}
    </Card>
  );
};
